import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { getOrganization, OrganizationDto, updateOrganization } from '@/service/overview';
import { useRequest } from 'ahooks';
import LoaderIcon from '@/assets/icons/Loader.svg';
import { CardTitle } from '@/components/ui/card';
import { useState } from 'react';
import { toast } from 'sonner';

const Profile = () => {
  const { data } = useRequest(getOrganization);
  const isVerified = data?.is_verified;

  if (!data) {
    return null;
  }
  return (
    <div>
      <Header />
      <div className="p-4">
        {!isVerified && (
          <div className="max-w-[420px] mx-auto mt-9 mb-4 p-4 bg-jen-background-secondary rounded-lg border border-jen-border-primary flex flex-col gap-3">
            <div className="flex  gap-3 items-center">
              <LoaderIcon className=" animate-spin" />
              <div className="text-[18px] text-black">Verifying your account</div>
            </div>
            <div className=" text-jen-content-secondary text-[16px]">
              We are reviewing your application and will send you an email to confirm your verification shortly.
            </div>
          </div>
        )}
        <ProfileTable initialData={data} />
      </div>
    </div>
  );
};

const Header = () => {
  return (
    <div className="px-8 py-6 flex justify-between border-b border-jen-border-primary">
      <CardTitle>Profile</CardTitle>
    </div>
  );
};

const ProfileTable = ({ initialData }: { initialData: OrganizationDto }) => {
  const [data, setData] = useState(initialData);

  const handleChange = (field: keyof OrganizationDto) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setData((prevData) => ({
      ...prevData,
      [field]: newValue,
    }));
  };

  const handleBlur = (field: keyof OrganizationDto) => async () => {
    if (data?.name && data?.contact_name) {
      try {
        await updateOrganization({ name: data.name, contact_name: data.contact_name });
      } catch (error) {
        toast.error('update failed');
      }
    }
  };

  return (
    <div className="space-y-4 max-w-[420px] mx-auto py-8">
      <div className="mb-4 text-[20px] text-[#111112]">Your Details</div>

      <div>
        <Label htmlFor="name">
          Name<span className="ml-1 text-jen-content-tertiary">Individual or organization</span>
        </Label>
        <Input
          id="name"
          name="name"
          placeholder="Individual or organization"
          value={data?.name || ''}
          onChange={handleChange('name')}
          className="mt-2 h-12"
          onBlur={handleBlur('name')}
          // onKeyDown={handleKeyDown('name')}
        />
      </div>

      <div>
        <Label htmlFor="contact_name">Key Contact Name</Label>
        <Input
          id="contact_name"
          name="contact_name"
          placeholder="Joe Bloggs"
          value={data?.contact_name || ''}
          onChange={handleChange('contact_name')}
          className="mt-2 h-12"
          onBlur={handleBlur('contact_name')}
          // onKeyDown={handleKeyDown('contact_name')}
        />
      </div>

      <div>
        <Label htmlFor="email">Your Email</Label>
        <Input
          id="email"
          name="email"
          type="email"
          disabled
          placeholder="Joe@Joebloggs.com"
          value={data?.email || ''}
          // onChange={handleChange('email')}
          className="mt-2 h-12"
        />
      </div>
    </div>
  );
};

export default Profile;
